export default __webpack_public_path__ + "static/media/project_ob_on.76804fbd.svg";